<template>
  <div class="dropdown">
    <button class="btn btn-primary dropdown-toggle" type="button" @click="toggleDropdown(data.id)">
      {{ $t("action") }}
    </button>
    <div class="dropdown-menu" v-if="isDropdownOpen(data.id)" aria-labelledby="dropdownMenuButton">
      <a class="dropdown-item" href="#" @click.prevent="testConnection(data)">
        <span v-if="loading" class="spinner-border spinner-border-sm loading" role="status" aria-hidden="true"></span>
        {{ $t("testConnection") }}
      </a>
      <a class="dropdown-item" href="#" @click.prevent="setAsDefault">
        {{ data.defaultSettings ? $t("removeDefault") : $t("setAsDefault")}}
      </a>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useStore } from "@/store";
import { notify } from "@kyvg/vue3-notification";

const store = useStore();

export default {
  name: "tableAction",
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      activeDropdown: null,
      loading: false
    };
  },
  mounted() {
    document.addEventListener("click", this.closeDropdown);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeDropdown);
  },
  methods: {
    toggleDropdown(id) {
      this.activeDropdown = this.activeDropdown === id ? null : id;
    },
    isDropdownOpen(id) {
      return this.activeDropdown === id;
    },
    closeDropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.activeDropdown = null;
      }
    },
    async testConnection(data) {
      let body = {
        ...this.data,
        isClickAction: true
    };
      this.loading = true;
      try {
        await this.$parent.$parent.$parent.testConnection(body);
      } finally {
        this.loading = false;
      }
    },
    async setAsDefault() {
  const updateDefaultSettings = !this.data.defaultSettings;
  let body = {
    ...this.data,
    defaultSettings: updateDefaultSettings,
    isClickAction: true
  };
  

  try {
    const response = await store.dispatch(GeneralActionTypes.CREATE_OR_UPDATE_SERVER, body);

    if (Number(response.statusCode) !== 200) {
      Swal.fire("Error", response.errors, "error");
    } else {
    
      if (response.entityData.defaultSettingsCheck) {
        Swal.fire("Info", this.$t('defaultSettingsCheck'), "info");
      } else {
        notify({
          title: this.$t('updateServer'),
          type: "success",
          duration: 4000,
        });
        this.$parent.$parent.$parent.getList();
      }
    }
  } catch (error) {
    Swal.fire("Error", "There was an error processing the request.", "error");
  }
},

  },
};
</script>

<style scoped>
.dropdown {
  margin-top: 2px;
  position: absolute !important;
}

.dropdown-toggle {
  background: #164B6C 0% 0% no-repeat padding-box !important;
  color: #fff !important;
  line-height: 5px !important;
  font-size: 13px !important;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  display: block !important;
  line-height: 10px !important;
  min-width: 10rem;
  border-color: #4c8cbb;
}

.dropdown-item {
  padding: 0.7rem 0.6rem !important;
  line-height: 6px !important;
  font-size: 14px !important;
  min-width: 5px;
}

.loading {
  margin-bottom: 1px;
  margin-right: 2px;
}

.dropdown-item:active {
  background-color: #164B6C;
}
</style>